export const loggedUser = {
  company: 'University of Southern California',
  siebelRowId: '2-5WCD6R',

  // data from user-details
  userContactInfo: {
    firstName: 'Keynote',
    lastName: 'Keynote',
    // userId: 815135,
    // userName: 'TEST003',
    // userName: 'KEYNOTE49',
    // userId: 765983,
    // userName: 'Keynote32',
    // userId: 607042,
    userName: 'cnemailtest@mailinator.com',
    userId: 3600976913,
    // userName: 'cart.us@test.com',
    // userId: 3601243925, // cartUS
    // userName: 'simona.creoleanu@thermofisher.com',
    // userId: 3601287547,

    contactInfo: {
      country: {
        isoCode: 'us'
      }
    }
  },

  userRoles: {
    scms: false,
    // roles: [],
    roles: ['Enterprise.CustomerServiceRepresentative']

  },

  currencyCode: 'USD',
  customerName: 'Keynote',
  displayIso: 'us',
  displayLang: 'en',
  displayType: 'b2ccmgt',
  emailAddress: 'ITQASupport@thermofisher.com',
  isCSR: false,
  partnerLogo: '',
  shipToNumber: '277488',
  unreadMessagesCount: '0',

  // data from /user-type endpoint
  isAnonymous: false,
  isB2BMasterUser: false,
  isCrmManager: false,
  isSosManager: false,
  userType: 'b2c'
};

export const mockRequestHeaders = {
  userName: loggedUser.userContactInfo.userName,
  userid: loggedUser.userContactInfo.userId,
  countryCode: loggedUser.userContactInfo.contactInfo.country.isoCode,
  languageCode: loggedUser.displayLang
};

export const customDesigns = [
  {
    name: 'Gene Expression Assays',
    designCategories: [
      {
        name: 'Plates and Arrays',
        showViewAll: true,
        showNext: false,
        showUploadFile: true,
        customDesigns: [
          {
            workspaceId: 360000001229813,
            name: 'bgsfg',
            description: '1 Passed, 0 Failed, 0 Predesigned ',
            lastModified: '11-Dec-2020',
            status: 'Design Complete',
            customProductCategory: 10,
            productCategoryFormat: 10,
            itemType: 'TaqMan® Array FAST 96 well Plates'
          },
          {
            workspaceId: 360000001229812,
            name: 'bgsfg',
            description: '1 Passed, 0 Failed, 0 Predesigned ',
            lastModified: '11-Dec-2020',
            status: 'Design Complete',
            customProductCategory: 10,
            productCategoryFormat: 10,
            itemType: 'TaqMan® Array FAST 96 well Plates'
          }
        ]
      },
      {
        name: 'Single Tubes',
        showViewAll: true,
        showNext: false,
        showUploadFile: true,
        customDesigns: [
          {
            workspaceId: 360000001243465,
            name: 'bgsfg',
            description: '1 Passed, 0 Failed, 0 Predesigned ',
            lastModified: '11-Dec-2020',
            status: 'Design Pending',
            customProductCategory: 10,
            productCategoryFormat: 10,
            itemType: 'TaqMan® Array FAST 96 well Plates'
          },
          {
            workspaceId: 360000001243422,
            name: 'bgsfg',
            description: '1 Passed, 0 Failed, 0 Predesigned ',
            lastModified: '11-Dec-2020',
            status: 'Design Complete',
            customProductCategory: 10,
            productCategoryFormat: 10,
            itemType: 'TaqMan® Array FAST 96 well Plates'
          }
        ]
      }
    ]
  },
  {
    name: 'Genotyping Assays',
    designCategories: [
      {
        name: 'Single Tubes',
        showViewAll: true,
        showNext: false,
        showUploadFile: true,
        customDesigns: [
          {
            workspaceId: 360000001236104,
            name: 'bgsfg',
            description: '1 Passed, 0 Failed, 0 Predesigned ',
            lastModified: '11-Dec-2020',
            status: 'Design Complete',
            customProductCategory: 10,
            productCategoryFormat: 10,
            itemType: 'TaqMan® Array FAST 96 well Plates'
          },
          {
            workspaceId: 360000001231917,
            name: 'bgsfg',
            description: '1 Passed, 0 Failed, 0 Predesigned ',
            lastModified: '11-Dec-2020',
            status: 'Design Pending',
            customProductCategory: 10,
            productCategoryFormat: 10,
            itemType: 'TaqMan® Array FAST 96 well Plates'
          }
        ]
      }
    ]
  },
  {
    name: 'Copy Number Assays',
    designCategories: [
      {
        name: 'Single Tubes',
        showViewAll: true,
        showNext: false,
        showUploadFile: true,
        customDesigns: [
          {
            workspaceId: 360000001231920,
            name: 'bgsfg',
            description: '1 Passed, 0 Failed, 0 Predesigned ',
            lastModified: '11-Dec-2020',
            status: 'Design Pending',
            customProductCategory: 10,
            productCategoryFormat: 10,
            itemType: 'TaqMan® Array FAST 96 well Plates'
          },
          {
            workspaceId: 360000001231919,
            name: 'bgsfg',
            description: '1 Passed, 0 Failed, 0 Predesigned ',
            lastModified: '11-Dec-2020',
            status: 'Design Complete',
            customProductCategory: 10,
            productCategoryFormat: 10,
            itemType: 'TaqMan® Array FAST 96 well Plates'
          }
        ]
      }
    ]
  }
];

export const productsMocks = [{
  customProductCategory: 40,
  description: 'Test orders please do not process',
  itemType: 'Custom miRNA Array Panels',
  lastModified: '21-May-2021',
  name: 'TestAssay',
  productCategoryFormat: 10,
  status: 'Design Complete',
  workspaceId: 360000001241992,
}, {
  customProductCategory: 40,
  description: 'Test orders please do not process',
  itemType: 'Custom miRNA Array Panels',
  lastModified: '21-May-2021',
  name: 'TestAssay',
  productCategoryFormat: 10,
  status: 'Design Complete',
  workspaceId: 360000001241993,
}, {
  customProductCategory: 40,
  description: 'Test orders please do not process',
  itemType: 'Custom miRNA Array Panels',
  lastModified: '21-May-2021',
  name: 'TestAssay',
  productCategoryFormat: 10,
  status: 'Design Complete',
  workspaceId: 360000001241994,
}, {
  customProductCategory: 40,
  description: 'Test orders please do not process',
  itemType: 'Custom miRNA Array Panels',
  lastModified: '21-May-2021',
  name: 'TestAssay',
  productCategoryFormat: 10,
  status: 'Design Complete',
  workspaceId: 360000001241995,
}];

export const filesToBeUploaded = [
  {
    status: 'PENDING',
    id: 'dac8f364-4e86-4f57-b95c-0db6158a9613',
    name: 'Andrei Vancea (3).pdf',
    path: 'Andrei Vancea (3).pdf',
    size: 441785,
    type: 'application/pdf',
    isUploading: true,
    uploaded: false,
    error: ''
  },
  {
    status: 'PENDING',
    id: 'a6d78650-9e6a-4692-8ef8-4b59c0900eb2',
    name: 'SomethingElse.pdf',
    path: 'SomethingElse.pdf.pdf',
    size: 441785,
    type: 'application/pdf',
    isUploading: false,
    uploaded: true,
    error: ''
  },
  {
    status: 'PENDING',
    id: '7bf80106-ce42-4f5d-9d38-f7a12fcf4fec',
    name: 'SomethingElse2.pdf',
    path: 'SomethingElse2.pdf',
    size: 441785,
    type: 'application/pdf',
    isUploading: false,
    uploaded: true,
    error: 'Something went wrong'
  }
];

export const staticMenuItems = [
  {
    name: 'Link 1',
    productLink: 'Product link 1'
  },
  {
    name: 'Link 2',
    productLink: 'Product link 2'
  },
  {
    name: 'Link 3',
    productLink: 'Product link 3'
  },
  {
    name: 'Link 4',
    productLink: 'Product link 4'
  }
];
